import { createApp } from 'vue'
import App from './App.vue'
import i18n from "@/locales/i18n";
import filters from "@/filters/filters";


const app = createApp(App);
app.use(i18n);

app.config.globalProperties.$filters = filters;

app.mount('#egcf-speaker-list')
